<template>
    <div
        v-if="previewOnly || !detected"
        class="relative w-full overflow-hidden rounded-lg border-hairline border-theme-border bg-theme-hover"
        :class="{ 'mx-auto max-w-md': isNarrowEmbed }"
        :style="{ aspectRatio }"
    >
        <div
            class="absolute inset-0 flex flex-col items-center justify-center gap-1 text-theme-muted"
        >
            <span class="text-xl">{{ platformIcon }}</span>
            <span class="text-xs font-medium">{{ platformLabel }}</span>
        </div>
    </div>

    <div
        v-else
        class="relative w-full overflow-hidden rounded-lg border-hairline border-theme-border bg-theme-card"
        :class="{ 'mx-auto max-w-md': isNarrowEmbed }"
        :style="{ aspectRatio }"
    >
        <!-- sandbox: contiene lo que puede hacer la página embebida
        (Instagram/TikTok/YouTube) — sin esto quedaba libre para tomar el
        foco, pedir fullscreen o navegar el top frame, e interfería con el
        resto del editor (ver bug reportado: "Agregar bloque" dejaba de
        responder con un bloque de redes sociales en la lista). Los cuatro
        permisos son los mínimos para que el embed siga renderizando y sus
        links "ver en Instagram/TikTok" sigan abriendo en pestaña nueva.
        scrolling="no": el documento embebido (de otro origen, no podemos
        tocar su CSS) muestra su propia scrollbar nativa cuando su
        contenido real es más alto que el aspect-ratio estimado acá — este
        atributo (deprecado pero todavía soportado en todos los browsers)
        es la única forma de ocultar esa scrollbar desde afuera. -->
        <iframe
            :src="detected.embedUrl"
            :title="platformLabel"
            class="absolute inset-0 h-full w-full"
            frameborder="0"
            scrolling="no"
            loading="lazy"
            referrerpolicy="strict-origin-when-cross-origin"
            sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
        ></iframe>
    </div>
</template>

<script>
import {
    SOCIAL_PLATFORM_ICONS,
    SOCIAL_PLATFORM_LABELS,
    detectSocialEmbed
} from "@/common/social-embeds";

export default {
    name: "MediaSegment",
    props: {
        mediaType: { type: String, required: true },
        link: { type: String, required: true },
        previewOnly: { type: Boolean, default: false }
    },
    computed: {
        detected() {
            return detectSocialEmbed(this.link);
        },
        aspectRatio() {
            return this.detected?.aspectRatio || "1 / 1";
        },
        // YouTube es horizontal (16/9): a todo el ancho se ve como un
        // reproductor de video normal. Instagram y TikTok son verticales
        // (ver aspectRatio en detectSocialEmbed) — a todo el ancho del
        // canvas del editor (hasta 1024px) la altura se dispara varios
        // miles de px. Se limitan a un ancho medio y centrado.
        isNarrowEmbed() {
            return (this.detected?.platform || this.mediaType) !== "youtube";
        },
        platformLabel() {
            return SOCIAL_PLATFORM_LABELS[this.mediaType] || "Publicación";
        },
        platformIcon() {
            return SOCIAL_PLATFORM_ICONS[this.mediaType] || "🔗";
        }
    }
};
</script>
